module.exports = __webpack_public_path__ + "static/media/bg4.ae3c874d.jpg";